"use client";

import { useEffect } from "react";
import { useAuthStore } from "@/stores/authStore";

/** Applies `html.dark` from persisted user `ui_theme` (default light). */
export function ThemeSync() {
  const uiTheme = useAuthStore((s) => s.user?.ui_theme);

  useEffect(() => {
    const resolved = uiTheme === "dark" ? "dark" : "light";
    document.documentElement.classList.toggle("dark", resolved === "dark");
  }, [uiTheme]);

  return null;
}
